<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col>
                Pin Types
              </v-col>
              <v-col align="end">
                <v-btn @click="openNewPinTypeDialog" depressed color="primary">
                  Create New PinType
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row justify="space-between">
              <v-col cols="auto">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="auto" align="end">
                <v-select
                  hide-details
                  outlined
                  placeholder="Filter By Status"
                  dense
                  v-model="selectedState"
                  @change="stateSelected"
                  :items="['active', 'deleted']"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="pinTypes"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
            v-if="item.state !== 'deleted'"
            small
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div>
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>

    <new-pin-type-dialog ref="newPinTypeDialog" />
    <edit-pin-type-dialog :pinDetails="editedItem" ref="editPinTypeDialog" />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewPinTypeDialog from "../components/NewPinTypeDialog";
import EditPinTypeDialog from "../components/EditPinTypeDialog";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: { NewPinTypeDialog, EditPinTypeDialog },
  data() {
    return {
      selectedState: "",
      search: "",
      dialogDelete: false,
      itemToDelete: {
        name: "",
        fontFamily: 0,
        fontName: 0,
        backgroundColor: 0,
        fontColor: 0,
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Status",
          value: "state",
        },
        // { text: "Font Family", value: "fontFamily" },
        // { text: "Font Name", value: "fontName" },
        // { text: "Background Color", value: "backgroundColor" },
        // { text: "Font Color", value: "fontColor" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        name: "",
        fontFamily: 0,
        fontName: 0,
        backgroundColor: 0,
        fontColor: 0,
      },
      editedIndex: -1,
      defaultItem: {
        name: "",
        fontFamily: 0,
        fontName: 0,
        backgroundColor: 0,
        fontColor: 0,
      },
      //   pinTypes: [
      //     {
      //       name: "Events",
      //       fontFamily: "MeterialDesignIcons",
      //       fontName: "",
      //       backgroundColor: "",
      //       fontColor: "",
      //     },
      //   ],
    };
  },
  computed: {
    ...mapState("$_home", ["pinTypes"]),
  },
  created() {
    if (this.pinTypes.length === 0) {
      this.getPinTypes({ collection: "pinTypes", mutation: "updatePinTypes" });
    }
  },
  methods: {
    ...mapActions({
      getPinTypes: "$_home/getContent",
      getPinTypesByState: "$_home/getContentByState",
      deletePinType: "$_home/deleteContent",
    }),
    stateSelected(state) {
      console.log(state);
      switch (state) {
        case "deleted":
          this.getPinTypesByState({
            collection: "pinTypes",
            mutation: "updatePinTypes",
            state,
          });
          break;
        case "active":
          this.getPinTypes({
            collection: "pinTypes",
            mutation: "updatePinTypes",
          });
          break;
      }
    },
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    openNewPinTypeDialog() {
      this.$refs.newPinTypeDialog.toggleDialog();
    },
    editItem(item) {
      this.editedIndex = this.pinTypes.indexOf(item);
      this.editedItem = Object.assign({}, this.pinTypes[this.editedIndex]);

      console.log("Edited Item: ", this.editedItem);

      this.$refs.editPinTypeDialog.toggleDialog(this.editedItem);
    },
    deleteItem(item) {
      this.editedIndex = this.pinTypes.indexOf(item);
      this.itemToDelete = Object.assign({}, this.pinTypes[this.editedIndex]);
      this.dialogDelete = true;

      console.log(item);
    },
    deleteItemConfirm() {
      this.deletePinType({
        details: this.itemToDelete,
        collection: "pinTypes",
        type: "Pin",
      }).then(() => {
        this.dialogDelete = false;
        this.getPinTypes({
          collection: "pinTypes",
          mutation: "updatePinTypes",
        });
      });
    },
  },
};
</script>

<style></style>
